import React from "react";
import BannerCard from "@/components/ui/banner-card";
import KeyFacts from "@/components/pages/country/key-facts";
import Insights from "@/components/pages/country/insights";
import AdditonalResources from "@/components/pages/country/additonal-resources";
import {
  keyFacts,
  climateImpacts,
  stories,
  partners,
  seo,
  jsonLd,
  insights,
  learnMore,
} from "@/data/bangladesh";
import ClimateImpacts from "@/components/pages/country/climate-impacts";
import Stories from "@/components/pages/country/stories";
import Partners from "@/components/pages/country/partners";
import States from "@/components/pages/country/states";
import Section from "@/components/ui/section";
import Head from "next/head";
import Seo from "@/utils/seo";
export default function Bangladesh() {
  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "Bangladesh",
          image: "/images/bangladesh/bangladesh banner 1600x400.webp",
        }}
        isActive={true}
        variant="single"
        description="PCI operates two initiatives in Bangladesh: Migrants Resilience Collaborative and the Climate Resilience Initiative."
      />
      <KeyFacts data={keyFacts} />
      <ClimateImpacts data={climateImpacts} columns={3} />
      <Stories
        data={stories}
        title="Stories of climate-affected internal migrants from Bangladesh"
      />
      <Partners data={partners} />
      <States
        map="/images/maps/Migration Map_Bangladesh2.png"
        title="Geographical Presence of PCI"
      />
      <Section className="bg-[#F4F9FF] -mt-20">
        <h2 className="text-darkBlue text-center mb-12">
          About Internal Migration in Bangladesh
        </h2>
        <Insights data={insights} />
      </Section>
      <AdditonalResources data={learnMore} />
    </>
  );
}
